import React, { ReactNode } from 'react';
import styled from 'styled-components';

const CardContainer = styled.div`
  width: 80%;
  display: grid;
  grid-template-columns: 10% 90%;
  width: 100%;
  min-width: 265px;
  min-height: 120px;
  border-radius: 15px;

  cursor: pointer;
  transition: transform 0.3s ease; /* Transição suave */

  &:hover {
    transform: scale(1.005); /* Aumenta 5% */
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  }
`;

const CardDetalheLateral = styled.div<{ color?: string; iconSize?: string }>`
  background-color: ${(props) => props.color};
  border-radius: 20px 0 0 20px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${(props) => props.iconSize || '24px'};
  flex: 1;
`;

const CardConteudo = styled.div<{ color?: string }>`
  background-color: white;
  border-radius: 0 20px 20px 0;
  flex: 3;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 45px;
`;

const CardTitulo = styled.div`
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 5px;
  color: #1351b4;
`;

const CardResponsavel = styled.div`
  font-size: 0.9rem;
  color: #717171;
  margin-bottom: 5px;
`;

const CardDescricao = styled.div`
  font-size: 1rem;
  color: #1351b4;
`;

interface CardInformesProps {
  icon: ReactNode;
  titulo: string;
  data_informe: string;

  descricao: string;
  onClick?: () => void;
  color?: string;
  iconSize?: string;
}

function CardInformes(props: CardInformesProps) {
  const {
    icon,
    titulo,
    data_informe,

    descricao,
    onClick,
    color,
    iconSize,
  } = props;

  return (
    <CardContainer onClick={onClick}>
      <CardDetalheLateral color={color} iconSize={iconSize}>
        {icon}
      </CardDetalheLateral>
      <CardConteudo>
        <CardTitulo>{titulo}</CardTitulo>
        <CardResponsavel>{data_informe}</CardResponsavel>
        <CardDescricao>{descricao}</CardDescricao>
      </CardConteudo>
    </CardContainer>
  );
}

export default CardInformes;
